import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  MessageCircle, Mail, Send, BarChart3, ShoppingCart, Calendar,
  FileText, Database, Globe, CreditCard, Phone, Headphones,
  Briefcase, Stethoscope, Home, Bot, Check
} from "lucide-react";

const INTEGRATIONS = [
  { name: "WhatsApp", desc: "Messaging", color: "#25D366", icon: MessageCircle },
  { name: "Telegram", desc: "Messaging", color: "#0088cc", icon: Send },
  { name: "Email", desc: "Communication", color: "#EA4335", icon: Mail },
  { name: "Slack", desc: "Team collaboration", color: "#4A154B", icon: MessageCircle },
  { name: "Discord", desc: "Community", color: "#5865F2", icon: Headphones },
  { name: "Google Sheets", desc: "Spreadsheets", color: "#34A853", icon: FileText },
  { name: "Notion", desc: "Knowledge & docs", color: "#000000", icon: Database },
  { name: "Stripe", desc: "Payments", color: "#635BFF", icon: CreditCard },
  { name: "HubSpot", desc: "CRM", color: "#FF7A59", icon: Briefcase },
  { name: "Shopify", desc: "E-commerce", color: "#96BF48", icon: ShoppingCart },
  { name: "Google Calendar", desc: "Scheduling", color: "#4285F4", icon: Calendar },
  { name: "Zapier", desc: "Automation", color: "#FF4A00", icon: Globe },
];

export default function IntegrationsSection() {
  const { t } = useTranslation();

  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 py-24 border-t border-zinc-900">
      <div className="text-center mb-16">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-4" aria-hidden="true">// {t('integrations_section.title').toUpperCase()}</div>
        <h2 className="font-display text-4xl md:text-5xl uppercase leading-tight">{t('integrations_section.title')}</h2>
        <p className="text-zinc-400 max-w-xl mx-auto mt-4">{t('integrations_section.subtitle')}</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {INTEGRATIONS.map((ig) => {
          const Icon = ig.icon;
          return (
            <div
              key={ig.name}
              className="group relative border border-zinc-800 rounded-lg p-4 flex flex-col items-center gap-3 hover:border-amber-500/50 transition-all hover:bg-zinc-950/50 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${ig.color}15`, border: `1px solid ${ig.color}30` }}>
                <Icon className="w-6 h-6" style={{ color: ig.color }} />
              </div>
              <div className="text-center">
                <div className="font-display text-sm uppercase text-white group-hover:text-amber-500 transition-colors">{ig.name}</div>
                <div className="text-[10px] text-zinc-500 font-mono mt-1">{ig.desc}</div>
              </div>
              <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
                <Check className="w-4 h-4 text-amber-500" />
              </div>
            </div>
          );
        })}
      </div>

      <div className="text-center mt-8">
        <Link to="/integrations" className="inline-flex items-center gap-2 text-amber-500 hover:text-amber-400 font-mono text-xs uppercase tracking-[0.15em] transition-colors">
          {t('integrations_section.view_all')}
        </Link>
      </div>
    </section>
  );
}
